import { render, staticRenderFns } from "./acceptanceDetail.vue?vue&type=template&id=a5dd6246&scoped=true"
import script from "./acceptanceDetail.vue?vue&type=script&lang=js"
export * from "./acceptanceDetail.vue?vue&type=script&lang=js"
import style0 from "./acceptanceDetail.vue?vue&type=style&index=0&id=a5dd6246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5dd6246",
  null
  
)

export default component.exports